/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as DrillableTreemapLayerSpec } from '../../../../layer/preset/treeMap/drillableTreemap';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

type DrillableTreemapLayerType = StandardChartLayerSpec &
  DrillableTreemapLayerSpec &
  ILayerTypeSpec;

// 定义树形数据节点接口
interface TreeNode {
  [key: string]: unknown;
  children?: TreeNode[];
}

// 创建可下钻矩形树图数据类型验证器
const validateDrillableTreemapDataTypes = createDataTypeValidator('drillableTreemap', [
  { field: 'x', type: 'string' },
  { field: 'y', type: 'number' },
  { field: 'group', type: ['string', 'date'] }
]);

// 创建可下钻矩形树图编码验证器
const validateDrillableTreemapEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y' },
  { field: 'group' }
]);

/**
 * 检查数据结构是否包含层级关系
 * @param layer 图层配置
 * @param data 数据
 */
function validateHierarchicalData(layer: DrillableTreemapLayerType, data: Data) {
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  if (!values.length) {
    return;
  }

  // 检查是否包含层级结构
  const hasValidHierarchy = values.some(
    (item: TreeNode) => Array.isArray(item.children) && item.children.length > 0
  );

  if (!hasValidHierarchy) {
    utils.logger.warn(
      'warning',
      `The data for "${layer.type}" layer must contain hierarchical structure with "children" property`
    );
    layer.__isEncodingValid = false;
  }
}

// 额外的检查函数
const additionalDrillableTreemapChecks = (layer: DrillableTreemapLayerType, data: Data) => {
  // 检查是否具有层级结构
  validateHierarchicalData(layer, data);
};

// 创建并导出可下钻矩形树图处理器
export const drillableTreemap = createLayerProcessor<DrillableTreemapLayerType>(
  'drillableTreemap',
  validateDrillableTreemapEncoding,
  validateDrillableTreemapDataTypes,
  additionalDrillableTreemapChecks
);
